import { html, render } from "lit";
import { keyed } from "lit/directives/keyed.js";

import "../../elements/bible-reader";
import "./elements/bible-book-explore";
import "./elements/bible-book-explore-cta";
import "./elements/bible-book-explore-section";
import "./elements/bible-navigation";
import "./elements/bible-navigation-menu";
import "./elements/bible-navigation-query-button";
import "./elements/bible-navigation-translation-button";
import "./elements/bible-video-feature";
import "./elements/bible-video-play-button";
import "./elements/bible-video-player-overlay";
import "./elements/bible-video-player";

export const $page = document.querySelector("#Page")!;

export function ariaBoolean(value: boolean) {
  return value ? "true" : "false";
}

export function presentVideo(params: {
  trigger: HTMLElement;
  video: { muxId: string; title: string };
}) {
  render(
    html`
      ${keyed(
        Date.now(),
        html`<bible-video-player-overlay
          .trigger=${params.trigger}
          .video=${params.video}
        ></bible-video-player-overlay>`,
      )}
    `,
    document.body,
  );
}
